import { render, staticRenderFns } from "./ContestRow.vue?vue&type=template&id=a1777e10&scoped=true"
import script from "./ContestRow.vue?vue&type=script&lang=ts"
export * from "./ContestRow.vue?vue&type=script&lang=ts"
import style0 from "./ContestRow.vue?vue&type=style&index=0&id=a1777e10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1777e10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1777e10')) {
      api.createRecord('a1777e10', component.options)
    } else {
      api.reload('a1777e10', component.options)
    }
    module.hot.accept("./ContestRow.vue?vue&type=template&id=a1777e10&scoped=true", function () {
      api.rerender('a1777e10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/ContestRow.vue"
export default component.exports